
<div style="border-radius: 50%; aspect-ratio: 1/1; font-weight: bold; color: pink;
            width: 1.6em; height: 1.6em;border: 0px dashed var(--secondary); position: relative; text-align: center;z-index: 101; cursor: pointer;"
        (click)="$event.stopPropagation(); showingOptions = !showingOptions"
        class="d-flex flex-column align-items-center justify-content-center" (clickOutside)="showingOptions = false"
        >
        <i    *ngIf="nowValue" [class]="nowValue"></i>
        <span *ngIf="!nowValue">?</span>
        
        <div *ngIf="showingOptions" style="position: absolute; top: 100%; 
                    left: 0px; width: 5em;  z-index: 100; background-color: var(--white);
                color: var(--primary) 
        " 
            class="d-flex flex-column justify-content-center align-items-center w-100">
            <span *ngFor="let option of icons" class="w-100">
                <i [class]="option" class="w-100" style="text-align: center;" (click)="$event.stopPropagation(); selectOption(option)"></i>
            </span>

        </div>

</div>